import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import './ReviewModal.css';

function ReviewModal({ isOpen, onClose, customerId, existingReview = null, onSave = null }) {
    const [reviewType, setReviewType] = useState(existingReview?.reviewType || 'POSITIVE');
    const [description, setDescription] = useState(existingReview?.description || '');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Reset form when modal opens or existingReview changes
        if (existingReview) {
            setReviewType(existingReview.reviewType);
            setDescription(existingReview.description);
        } else {
            setReviewType('POSITIVE');
            setDescription('');
        }
    }, [isOpen, existingReview]);

    const handleSubmit = () => {
        if (!customerId && !existingReview?.id) {
            setError('Salvați mai întâi clientul pentru a adăuga o recenzie.');
            return;
        }

        setIsSubmitting(true);
        setError(null);

        try {
            // Create review data structure
            const reviewData = {
                id: existingReview?.id, // Keep existing ID if available
                customerId,
                reviewType,
                description
            };

            // Just pass the review data to the parent component
            if (onSave) {
                onSave(reviewData);
            }
            onClose();
        } catch (err) {
            console.error('Error preparing review data:', err);
            setError('A apărut o eroare la pregătirea datelor pentru recenzie.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="review-modal-overlay">
            <div className="review-modal-content">
                <div className="review-modal-header">
                    <h2>{existingReview ? 'Editare Recenzie' : 'Adăugare Recenzie'}</h2>
                    <button className="review-close-button" onClick={() => onClose()}>
                        <FiX />
                    </button>
                </div>

                <div className="review-modal-body">
                    <div className="review-type-selector">
                        <label>Tip Recenzie:</label>
                        <div className="review-type-options">
                            <label className={`review-type-option ${reviewType === 'POSITIVE' ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="reviewType"
                                    value="POSITIVE"
                                    checked={reviewType === 'POSITIVE'}
                                    onChange={() => setReviewType('POSITIVE')}
                                />
                                <span className="review-type-text">Pozitiv</span>
                            </label>
                            <label className={`review-type-option ${reviewType === 'NEGATIVE' ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="reviewType"
                                    value="NEGATIVE"
                                    checked={reviewType === 'NEGATIVE'}
                                    onChange={() => setReviewType('NEGATIVE')}
                                />
                                <span className="review-type-text">Negativ</span>
                            </label>
                        </div>
                    </div>

                    <div className="review-description">
                        <label htmlFor="reviewDescription">Descriere:</label>
                        <textarea
                            id="reviewDescription"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Introduceți descrierea recenziei"
                            rows="4"
                        />
                    </div>

                    {error && <div className="review-error">{error}</div>}
                </div>

                <div className="review-modal-footer">
                    <button
                        className="review-cancel-button"
                        onClick={() => onClose()}
                        disabled={isSubmitting}
                    >
                        Anulează
                    </button>
                    <button
                        className="review-save-button"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Se salvează...' : 'Salvează'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ReviewModal;